<template>
  <CRow
    class="d-flex flex-wrap justify-content-between align-items-start m-0 w-100"
  >
    <CCol sm="12" class="mt-2 mb-2">
      <CRow class="px-3">
        <h4>
          <span>Deine letzten 3 Monate auf Loonity... 📊</span>
        </h4>
      </CRow>
    </CCol>
    <CCol sm="12" lg="6" class="">
      <CCard>
        <CCardHeader>
          <h6>
            {{ $t("family.dashboard.graphs.orders.title") }}
          </h6>
        </CCardHeader>
        <CCardBody>
          <div class="d-flex justify-content-center" v-if="loading">
            <CSpinner color="primary" />
          </div>
          <div v-else>
            <div
              class="d-flex justify-content-start"
              v-if="noData.orders && !loading"
            >
              {{ $t("family.dashboard.graphs.noActivity") }}
            </div>

            <CChartBar
              v-else
              :datasets="dataSetOrders"
              :labels="defaultLabels"
              :options="options"
            />
          </div>
        </CCardBody>
      </CCard>
    </CCol>

    <CCol sm="12" lg="6" class="">
      <CCard>
        <CCardHeader>
          <h6>
            {{ $t("family.dashboard.graphs.products.title") }}
          </h6>
        </CCardHeader>
        <CCardBody>
          <div class="d-flex justify-content-center" v-if="loading">
            <CSpinner color="primary" />
          </div>
          <div v-else>
            <div
              class="d-flex justify-content-start"
              v-if="noData.products && !loading"
            >
              {{ $t("family.dashboard.graphs.noActivity") }}
            </div>

            <CChartBar
              v-else
              :datasets="dataSetProducts"
              :labels="defaultLabels"
              :options="options"
            />
          </div>
        </CCardBody>
      </CCard>
    </CCol>

    <CCol sm="12" lg="6" class="">
      <CCard>
        <CCardHeader>
          <h6>
            {{ $t("family.dashboard.graphs.chf.title") }}
          </h6>
        </CCardHeader>
        <CCardBody>
          <div class="d-flex justify-content-center" v-if="loading">
            <CSpinner color="primary" />
          </div>
          <div v-else>
            <div
              class="d-flex justify-content-start"
              v-if="noData.chf && !loading"
            >
              {{ $t("family.dashboard.graphs.noActivity") }}
            </div>

            <CChartBar
              v-else
              :datasets="dataSetCHF"
              :labels="defaultLabels"
              :options="optionsCHF"
            />
          </div>
        </CCardBody>
      </CCard>
    </CCol>

    <DashboardFamilyPP />
  </CRow>
</template>

<script>
import { CChartLine, CChartBar } from "@coreui/vue-chartjs";
import { apiGet } from "../../helpers/apiHelper";
import DashboardFamilyPP from "./DashboardFamilyPP.vue";

export default {
  data() {
    return {
      loading: false,
      dataset: [],
      noData: {
        orders: true,
        products: true,
        chf: true,
      },
      options: {
        legend: {
          display: false,
        },
        scales: {
          xAxes: [
            {
              gridLines: {
                display: false,
              },
            },
          ],
          yAxes: [
            {
              id: "y",
              type: "linear",
              position: "left",
              gridLines: {
                display: true,
              },
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
      },
      optionsCHF: {
        legend: {
          display: false,
        },
        scales: {
          xAxes: [
            {
              gridLines: {
                display: false,
              },
            },
          ],
          yAxes: [
            {
              id: "yCHF",
              type: "linear",
              position: "left",
              grid: {
                display: false,
              },
              ticks: {
                callback: function (value, index, values) {
                  return "CHF " + value;
                },
              },
            },
          ],
        },
      },
    };
  },

  mounted() {
    this.getData();
  },

  watch: {
    // whenever question changes, this function will run
    familyId(newfamilyId, oldfamilyId) {
      if (newfamilyId != oldfamilyId) {
        this.getData();
      }
    },
  },

  methods: {
    async getData() {
      const self = this;
      this.loading = true;
      const familyId = this.familyId;

      const response = await apiGet("role_family_dash_orders", [familyId]);

      if (response && response.status === 200) {
        self.loading = false;
        let dataset = response.data.data.slice(-12);
        dataset = dataset.map((data) => {
          return {
            ...data,
            label: data.label.replace("week ", "W").replace("-", " - "),
          };
        });
        self.dataset = dataset;

        dataset.forEach((data) => {
          if (data.orders > 0) {
            self.noData.orders = false;
          }
          if (data.products > 0) {
            self.noData.products = false;
          }
          if (data.tot > 0) {
            self.noData.chf = false;
          }
        });

        return;
      }
    },
  },
  components: {
    CChartLine,
    CChartBar,
    DashboardFamilyPP,
  },
  computed: {
    familyId() {
      return this.$store.state.connections.current.family.id;
    },

    dataSetOrders() {
      let list_order = [];
      this.dataset.forEach(function (data, index) {
        list_order.push(data.orders);
      });
      return [
        {
          label: this.$t("family.dashboard.orders.label_orders"),
          borderColor: "#d75b4f",
          backgroundColor: "#d75b4f",
          pointBackgroundColor: "#d75b4f",
          data: list_order,
          yAxisID: "y",
        },
      ];
    },

    dataSetProducts() {
      let list_products = [];
      this.dataset.forEach(function (data, index) {
        list_products.push(data.products);
      });
      return [
        {
          label: this.$t("family.dashboard.orders.label_products"),
          borderColor: "#5ca6eb",
          backgroundColor: "#5ca6eb",
          pointBackgroundColor: "#5ca6eb",
          data: list_products,
          yAxisID: "y",
        },
      ];
    },

    dataSetCHF() {
      let list_chf = [];
      this.dataset.forEach(function (data, index) {
        list_chf.push(data.tot);
      });
      return [
        {
          label: "CHF",
          borderColor: "#90b44c",
          backgroundColor: "#90b44c",
          pointBackgroundColor: "#90b44c",
          data: list_chf,
          yAxisID: "yCHF",
        },
      ];
    },

    defaultLabels() {
      let list_labels = [];
      this.dataset.forEach(function (data, index) {
        list_labels.push(data.label);
      });
      return list_labels;
    },
  },
};
</script>
